module.exports = __webpack_public_path__ + "img/expenses-types.9e20068a.svg";